<template>
    <a href="#" @click.prevent="showModal()" v-html="popup_info_title_html" class="designer-question-popup-info-link txt-sm"></a>
    <div :id="htmlId" v-if="popup_info_inner_html !== ''" class="modal-window _lg" tabindex="-1">
        <div class="modal-window-inner">
            <div class="modal-header" style="border-bottom:0;">
                <button type="button" class="close" data-modal-hide><i class="far fa-times"></i></button>
            </div>
            <div class="modal-content" v-html="popup_info_inner_html">
            </div>
            <div class="modal-footer align-right">
                <button type="button" class="btn-default" data-modal-hide>Close</button>
            </div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    export default {
        data(){
            return {
              htmlId: this.component_id + '-modal',
            }
        },
        props: {
          popup_info_title_html: {
            default(){
              return '';
            }
          },
          popup_info_inner_html: {
            default(){
              return '';
            }
          },
        },
        methods: {
            showModal(){
                modal_window.show_modal('#' + this.htmlId);
            },
        }
    }
</script>
